import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

import styles from './Icon.module.less';
import { BoltIcon } from './BoltIcon';
import { BtcIcon } from './BtcIcon';
import { CheckmarkIcon } from './CheckmarkIcon';
import { ChevronDownIcon } from './ChevronDownIcon';
import { ChfIcon } from './ChfIcon';
import { CzkIcon } from './CzkIcon';
import { ErrorUpIcon } from './ErrorUpIcon';
import { EurIcon } from './EurIcon';
import { PlnIcon } from './PlnIcon';
import { UsdcIcon } from './UsdcIcon';
import { UsdtIcon } from './UsdtIcon';

export type IconType =
  | 'eur'
  | 'czk'
  | 'usdc'
  | 'usdt'
  | 'chf'
  | 'pln'
  | 'btc'
  | 'chevronDown'
  | 'errorUp'
  | 'checkmark'
  | 'bolt';

export interface IconProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  type: IconType;
  color?: string;
}

// Icons that take color props
const colorIconMap: Record<string, (props: { color: string }) => React.JSX.Element> = {
  checkmark: CheckmarkIcon,
  bolt: BoltIcon,
};

// Icons without color props
const simpleIconMap: Record<string, () => React.JSX.Element> = {
  eur: EurIcon,
  czk: CzkIcon,
  usdc: UsdcIcon,
  usdt: UsdtIcon,
  chf: ChfIcon,
  pln: PlnIcon,
  btc: BtcIcon,
  chevronDown: ChevronDownIcon,
  errorUp: ErrorUpIcon,
};

export function Icon({ type, color, className, style, ...props }: IconProps) {
  const isCircular = type === 'errorUp';

  // Check if it's a color icon
  if (colorIconMap[type]) {
    const IconComponent = colorIconMap[type];
    return (
      <div
        {...props}
        className={`${styles.icon} ${className ?? ''}`}
        style={{
          ...style,
          ...(isCircular && { borderRadius: '100%' }),
        }}
      >
        <IconComponent color={color ?? '#000000'} />
      </div>
    );
  }

  // Simple icon without color
  const IconComponent = simpleIconMap[type];
  if (!IconComponent) {
    return null;
  }

  return (
    <div
      {...props}
      className={`${styles.icon} ${className ?? ''}`}
      style={{
        ...style,
        ...(isCircular && { borderRadius: '100%' }),
      }}
    >
      <IconComponent />
    </div>
  );
}
